<div class="main-container">
  <div class="dashboard-header-intro">
    <div class="dashboard-header-intro-inner">
      <h1>{{ "phrases.conversion_rate" | translate }}</h1>
      <h2 *ngIf="!initialLoader">
        <ng-container *ngIf="!raisinInvestmentViewSelected">
          {{ barChartCr[0].diff || "0%" }}
        </ng-container>
        <ng-container *ngIf="raisinInvestmentViewSelected">
          {{ barChartCr[0]?.diff || "0%" }}
        </ng-container>
      </h2>

      <p
        *ngIf="!initialLoader"
        [class.compareValues]="compareObject.isActive && chartLoader"
      >
        <ng-container *ngIf="!compareObject.isActive">
          {{
            timeRangeSelected_translated
              | translate
                : {
                    date1: this.formatDateRange(this.startDate),
                    date2: this.formatDateRange(this.endDate),
                  }
          }}
        </ng-container>
        <ng-container *ngIf="compareObject.isActive">
          {{ ("phrases.previous_period" | translate) + ":" }}
          <span>
            {{ comparedResponseData.barChartCrDiff }}
            <span
              class="compareValues_icon"
              [class.compareValues_icon_negative]="
                comparedResponseData.barChartCrDiff_color == 1
              "
              [class.compareValues_icon_positive]="
                comparedResponseData.barChartCrDiff_color == 2
              "
            >
            </span>
          </span>
        </ng-container>
      </p>
      <div class="skeleton-fields" *ngIf="initialLoader">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '48px',
            outline: 'none',
            'margin-right': '0px',
            'margin-bottom': '0px',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div class="dashboard-header-intro-inner">
      <h1>{{ "phrases.revenue_per_visit" | translate }}</h1>

      <h2 *ngIf="!initialLoader">
        <ng-container *ngIf="!raisinInvestmentViewSelected">
          {{ barChartRpv[0].diff || "0%" }}
        </ng-container>
        <ng-container *ngIf="raisinInvestmentViewSelected">
          {{ barChartRpv[0]?.diff || "0%" }}
        </ng-container>
      </h2>

      <p
        *ngIf="!initialLoader"
        [class.compareValues]="compareObject.isActive && chartLoader"
      >
        <ng-container *ngIf="!compareObject.isActive">
          {{
            timeRangeSelected_translated
              | translate
                : {
                    date1: this.formatDateRange(this.startDate),
                    date2: this.formatDateRange(this.endDate),
                  }
          }}
        </ng-container>
        <ng-container *ngIf="compareObject.isActive">
          {{ ("phrases.previous_period" | translate) + ":" }}
          <span>
            {{ comparedResponseData.barChartRpvDiff }}
            <span
              class="compareValues_icon"
              [class.compareValues_icon_negative]="
                comparedResponseData.barChartRpvDiff_color == 1
              "
              [class.compareValues_icon_positive]="
                comparedResponseData.barChartRpvDiff_color == 2
              "
            >
            </span>
          </span>
        </ng-container>
      </p>
      <div class="skeleton-fields" *ngIf="initialLoader">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '48px',
            outline: 'none',
            'margin-right': '0px',
            'margin-bottom': '0px',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div
      class="dashboard-header-intro-inner"
      *ngIf="raisinInvestmentViewSelected"
    >
      <h1>
        {{ "phrases.revenue_per_register" | translate }}
      </h1>
      <h2 *ngIf="!initialLoader">
        {{ barChartRpr[0]?.diff || "0%" }}
      </h2>
      <p
        *ngIf="!initialLoader"
        [class.compareValues]="compareObject.isActive && chartLoader"
      >
        <ng-container *ngIf="!compareObject.isActive">
          {{
            timeRangeSelected_translated
              | translate
                : {
                    date1: this.formatDateRange(this.startDate),
                    date2: this.formatDateRange(this.endDate),
                  }
          }}
        </ng-container>
        <ng-container *ngIf="compareObject.isActive">
          {{ ("phrases.previous_period" | translate) + ":" }}
          <span>
            {{ comparedResponseData.barChartRprDiff }}
            <span
              class="compareValues_icon"
              [class.compareValues_icon_negative]="
                comparedResponseData.barChartRprDiff_color == 1
              "
              [class.compareValues_icon_positive]="
                comparedResponseData.barChartRprDiff_color == 2
              "
            >
            </span>
          </span>
        </ng-container>
      </p>
      <div class="skeleton-fields" *ngIf="initialLoader">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '48px',
            outline: 'none',
            margin: '0px',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div class="dashboard-header-intro-inner">
      <h1>{{ "phrases.average_order_value" | translate }}</h1>

      <h2 *ngIf="!initialLoader">
        <ng-container *ngIf="!raisinInvestmentViewSelected">
          {{ barChartAov[0].diff || "0%" }}
        </ng-container>
        <ng-container *ngIf="raisinInvestmentViewSelected">
          {{ barChartAov[0]?.diff || "0%" }}
        </ng-container>
      </h2>

      <p
        *ngIf="!initialLoader"
        [class.compareValues]="compareObject.isActive && chartLoader"
      >
        <ng-container *ngIf="!compareObject.isActive">
          {{
            timeRangeSelected_translated
              | translate
                : {
                    date1: this.formatDateRange(this.startDate),
                    date2: this.formatDateRange(this.endDate),
                  }
          }}
        </ng-container>
        <ng-container *ngIf="compareObject.isActive">
          {{ ("phrases.previous_period" | translate) + ":" }}
          <span>
            {{ comparedResponseData.barChartAovDiff }}
            <span
              class="compareValues_icon"
              [class.compareValues_icon_negative]="
                comparedResponseData.barChartAovDiff_color == 1
              "
              [class.compareValues_icon_positive]="
                comparedResponseData.barChartAovDiff_color == 2
              "
            >
            </span>
          </span>
        </ng-container>
      </p>
      <div class="skeleton-fields" *ngIf="initialLoader">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '48px',
            outline: 'none',
            'margin-right': '0px',
            'margin-bottom': '0px',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div
      class="dashboard-header-intro-inner"
      *ngIf="showATRBarchart && !raisinInvestmentViewSelected"
    >
      <h1>{{ "phrases.add_to_cart_ratio" | translate }}</h1>
      <h2 *ngIf="!initialLoader && !atrBarChartLoader">
        {{ barChartAtr[0].diff || 0 + "%" }}
      </h2>
      <p
        *ngIf="!initialLoader && !atrBarChartLoader"
        [class.compareValues]="compareObject.isActive && chartLoader"
      >
        <ng-container *ngIf="!compareObject.isActive">
          {{
            timeRangeSelected_translated
              | translate
                : {
                    date1: this.formatDateRange(this.startDate),
                    date2: this.formatDateRange(this.endDate),
                  }
          }}
        </ng-container>
        <ng-container *ngIf="compareObject.isActive">
          {{ ("phrases.previous_period" | translate) + ":" }}
          <span>
            {{ comparedResponseData.barChartAtrDiff }}
            <span
              class="compareValues_icon"
              [class.compareValues_icon_negative]="
                comparedResponseData.barChartAtrDiff_color == 1
              "
              [class.compareValues_icon_positive]="
                comparedResponseData.barChartAtrDiff_color == 2
              "
            >
            </span>
          </span>
        </ng-container>
      </p>
      <div
        class="skeleton-fields"
        [style]="
          initialLoader
            ? ''
            : 'margin: 10px 0 0 0 !important; box-sizing: border-box'
        "
        *ngIf="initialLoader || atrBarChartLoader"
      >
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '48px',
            outline: 'none',
            margin: '0px',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div class="dashboard-header-intro-inner">
      <h1 *ngIf="!nudgeLite">{{ "phrases.revenue_uplift" | translate }}</h1>
      <h1 *ngIf="nudgeLite">{{ "words.revenue" | translate }}</h1>

      <h2 *ngIf="!initialLoader">
        {{ revUplift | currencyFormatter }}
      </h2>

      <p
        *ngIf="!initialLoader"
        [class.compareValues]="compareObject.isActive && chartLoader"
      >
        <ng-container *ngIf="!compareObject.isActive">
          {{
            timeRangeSelected_translated
              | translate
                : {
                    date1: this.formatDateRange(this.startDate),
                    date2: this.formatDateRange(this.endDate),
                  }
          }}
        </ng-container>
        <ng-container *ngIf="compareObject.isActive">
          {{ ("phrases.previous_period" | translate) + ":" }}
          <span>
            {{ comparedResponseData.revUplift | currencyFormatter }}
            <span
              class="compareValues_icon"
              [class.compareValues_icon_negative]="
                comparedResponseData.revUplift_color == 1
              "
              [class.compareValues_icon_positive]="
                comparedResponseData.revUplift_color == 2
              "
            >
            </span>
          </span>
        </ng-container>
      </p>
      <div class="skeleton-fields" *ngIf="initialLoader">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '48px',
            outline: 'none',
            'margin-right': '0px',
            'margin-bottom': '0px',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!nudgeLite">
  <div class="dtpickerall" *ngIf="firstLoader">
    <div class="master_longitudinal_main-header master_performance_main-header">
      <!-- <mat-form-field
        *ngIf="previousSelectedStore == 'raisin'"
        class="bhm-option-container-1"
        style="
          --label-name: '{{ 'words.view' | translate }}:';
          --form-field-infix-width: 140px;
        "
      >
        <mat-select
          (selectionChange)="selectionDashboardViewChanged()"
          [(ngModel)]="selectedDashboardView"
        >
          <mat-option class="bhm-option-select-option-1" value="overall">
            {{ "words.overall" | translate }}
          </mat-option>
          <mat-option class="bhm-option-select-option-1" value="investments">
            {{ "words.investments" | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      <mat-form-field
        class="bhm-option-container-1"
        style="
          --label-name: '{{ 'words.device' | translate }}:';
          --form-field-infix-width: 140px;
        "
      >
        <mat-select
          (selectionChange)="selectionDeviceChanged($event)"
          [(ngModel)]="incentiveBarChart.selectedPlatform"
        >
          <mat-option class="bhm-option-select-option-1" value="overall">
            {{ "words.overall" | translate }}
          </mat-option>
          <mat-option class="bhm-option-select-option-1" value="desktop">
            {{ "words.desktop" | translate }}
          </mat-option>
          <mat-option class="bhm-option-select-option-1" value="tablet">
            {{ "words.tablet" | translate }}
          </mat-option>
          <mat-option class="bhm-option-select-option-1" value="mobile">
            {{ "words.mobile" | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        *ngIf="!raisinInvestmentViewSelected"
        class="bhm-option-container-1"
        style="
          --label-name: '{{ 'words.visits' | translate }}:';
          --form-field-infix-width: 160px;
        "
      >
        <mat-select
          (selectionChange)="filterVisits($event)"
          [value]="incentiveBarChart.selectedFilter"
        >
          <mat-option class="bhm-option-select-option-1" value="overall">
            {{ "words.overall" | translate }}
          </mat-option>
          <mat-option class="bhm-option-select-option-1" value="newVisit">
            {{ "phrases.new_visits" | translate }}
          </mat-option>
          <mat-option class="bhm-option-select-option-1" value="returningVisit">
            {{ "phrases.returning_visits" | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        *ngIf="!raisinInvestmentViewSelected"
        class="bhm-option-container-1"
        style="
          --label-name: '{{ 'words.outliers' | translate }}:';
          --form-field-infix-width: 150px;
        "
      >
        <mat-select
          [(ngModel)]="selectedOutlier"
          (selectionChange)="onOutlierChange($event)"
        >
          <mat-option
            class="bhm-option-select-option-1"
            *ngFor="let outlier of outliers"
            [value]="outlier"
          >
            {{ "words." + outlier | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div
        class="deviation-borders-toogle-container"
        *ngIf="previousSelectedStore == 'raisin'"
        style="margin-left: 10px"
      >
        <p>{{ "phrases.investment_view" | translate }}</p>
        <mat-slide-toggle
          class="example-margin"
          [(ngModel)]="raisinInvestmentViewSelected"
          (change)="selectionDashboardViewChanged()"
        >
        </mat-slide-toggle>
      </div>

      <div class="sidebtn-action-holder">
        <button
          mat-button
          class="btn_withoutIcon custom-button"
          [disabled]="rawDataButtonDisabled"
          (click)="generateRawData()"
          *ngIf="!isDouglasClient"
        >
          <span style="margin-right: 3px; top: -1px; position: relative">
            {{
              rawDataButtonDisabled
                ? ("words.processing" | translate) + ".."
                : ("phrases.raw_data" | translate)
            }}
          </span>
          <svg
            class="button_download_icon"
            style="width: 13px; position: relative; top: 1px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title></title>
            <g id="Complete">
              <g id="download">
                <g>
                  <path
                    d="M3,12.3v7a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-7"
                    fill="none"
                    stroke="var(--text-main-color)"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  ></path>
                  <g>
                    <polyline
                      data-name="Right"
                      fill="none"
                      id="Right-2"
                      points="7.9 12.3 12 16.3 16.1 12.3"
                      stroke="var(--text-main-color)"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    ></polyline>
                    <line
                      fill="none"
                      stroke="var(--text-main-color)"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      x1="12"
                      x2="12"
                      y1="2.7"
                      y2="14.2"
                    ></line>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </button>
        <button
          mat-button
          (click)="generateReport('report')"
          [disabled]="this.daysDifference <= 1"
          class="btn_withoutIcon custom-button"
        >
          <span style="margin-right: 3px; top: -1px; position: relative">
            {{ "words.report" | translate }}
          </span>
          <svg
            class="button_download_icon"
            style="width: 13px; position: relative; top: 1px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title></title>
            <g id="Complete">
              <g id="download">
                <g>
                  <path
                    d="M3,12.3v7a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-7"
                    fill="none"
                    stroke="var(--text-main-color)"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  ></path>
                  <g>
                    <polyline
                      data-name="Right"
                      fill="none"
                      id="Right-2"
                      points="7.9 12.3 12 16.3 16.1 12.3"
                      stroke="var(--text-main-color)"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    ></polyline>
                    <line
                      fill="none"
                      stroke="var(--text-main-color)"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      x1="12"
                      x2="12"
                      y1="2.7"
                      y2="14.2"
                    ></line>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="dtpickerall skeleton-fields" *ngIf="!firstLoader">
    <ngx-skeleton-loader
      count="3"
      [theme]="{
        height: '45.5px',
        outline: 'none',
        'margin-right': '15px',
        width: '180px',
        'background-color': '#37474f1a',
      }"
    ></ngx-skeleton-loader>
  </div>
  <div
    class="dtpickerall skeleton-fields exportation-skeleton"
    *ngIf="!firstLoader"
  >
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '35px',
        outline: 'none',
        'margin-right': '0px',
        width: '110px',
        'background-color': '#37474f1a',
      }"
    ></ngx-skeleton-loader>
  </div>
</div>

<div
  *ngIf="!nudgeLite"
  id="overall-card"
  style="width: 100%; flex-direction: column"
>
  <div
    class="ordersamount-container"
    fxFlex.gt-sm="100"
    fxFlex.gt-xs="100"
    fxFlex="100"
  >
    <div class="performance-box-orders_content">
      <ng-container *ngIf="firstLoader">
        <div class="performance-box-orders_table">
          <div class="performance-box-orders_table-header">
            <div class="performance-box-orders_table-item width80">
              <p></p>
            </div>
            <div class="performance-box-orders_table-item width120">
              <p
                [matTooltip]="
                  isChewyTarget
                    ? ('phrases.visits_who_have_seen_a_feature' | translate)
                    : raisinInvestmentViewSelected
                      ? ''
                      : ('phrases.visits_who_have_seen_at_least_one_nudge'
                        | translate)
                "
                matTooltipPosition="above"
              >
                {{
                  isChewyTarget
                    ? ("phrases.test_overall" | translate)
                    : ("phrases.nudges_overall" | translate)
                }}
              </p>
            </div>
            <div
              class="performance-box-orders_table-item width70"
              *ngIf="!nudgeLite"
            >
              <p
                matTooltip="{{
                  raisinInvestmentViewSelected
                    ? ''
                    : ('phrases.visits_who_would_have_seen_at_least_one_nudge_but_were_in_control_control_group_sees_no_nudges_at_all'
                      | translate)
                }}"
                matTooltipPosition="above"
              >
                {{ "words.control" | translate }}
              </p>
            </div>
            <div class="performance-box-orders_table-item">
              <p *ngIf="!nudgeLite">
                {{ "phrases.revenue_uplift" | translate }}
              </p>
              <p *ngIf="nudgeLite">{{ "words.revenue" | translate }}</p>
            </div>
          </div>
          <div class="performance-box-orders_table-body">
            <div
              class="performance-box-orders_table-row"
              *ngIf="raisinInvestmentViewSelected"
            >
              <div class="performance-box-orders_table-item width80">
                <p>{{ "words.visits" | translate }}</p>
              </div>
              <div class="performance-box-orders_table-item width120">
                <p>{{ investmentDashboardData?.nudge?.totalVisits }}</p>
              </div>
              <div
                class="performance-box-orders_table-item width70"
                *ngIf="!nudgeLite"
              >
                <p>{{ investmentDashboardData?.control?.totalVisits }}</p>
              </div>
              <div class="performance-box-orders_table-item">
                <p
                  [ngClass]="{
                    'uplift-green': checkUpliftColor(this.revUplift) === true,
                    'uplift-red': checkUpliftColor(this.revUplift) === false,
                    'uplift-none': checkUpliftColor(this.revUplift) === 0,
                  }"
                  style="white-space: nowrap"
                >
                  {{ revUplift | currencyFormatter }}
                </p>
              </div>
            </div>
            <div class="performance-box-orders_table-row">
              <div class="performance-box-orders_table-item width80">
                <p
                  matTooltip="{{
                    raisinInvestmentViewSelected
                      ? ''
                      : ('phrases.visit_definition' | translate)
                  }}"
                  matTooltipPosition="above"
                >
                  {{
                    raisinInvestmentViewSelected
                      ? ("words.registers" | translate)
                      : ("words.visits" | translate)
                  }}
                </p>
              </div>
              <div class="performance-box-orders_table-item width120">
                <p>
                  {{
                    raisinInvestmentViewSelected
                      ? investmentDashboardData?.nudge?.totalRegisters
                      : incentiveBarChart.crorderAmount.incentivesAmount.visits
                  }}
                </p>
              </div>
              <div
                class="performance-box-orders_table-item width70"
                *ngIf="!nudgeLite"
              >
                <p>
                  {{
                    raisinInvestmentViewSelected
                      ? investmentDashboardData?.control?.totalRegisters
                      : incentiveBarChart.crorderAmount.controlAmount.visits
                  }}
                </p>
              </div>
              <div class="performance-box-orders_table-item">
                <p
                  *ngIf="!raisinInvestmentViewSelected"
                  [ngClass]="{
                    'uplift-green': checkUpliftColor(this.revUplift) === true,
                    'uplift-red': checkUpliftColor(this.revUplift) === false,
                    'uplift-none': checkUpliftColor(this.revUplift) === 0,
                  }"
                  style="white-space: nowrap"
                >
                  {{ revUplift | currencyFormatter }}
                </p>
              </div>
            </div>
            <div
              class="performance-box-orders_table-row"
              *ngIf="compareObject.isActive"
            >
              <div class="performance-box-orders_table-item width80">
                <p
                  matTooltip="{{
                    'phrases.previous_period_visits' | translate
                  }}"
                  matTooltipPosition="above"
                  style="opacity: 0.5"
                >
                  {{ ("words.compared" | translate) + ":" }}
                </p>
              </div>
              <div class="performance-box-orders_table-item width120">
                <p class="compareValues">
                  <span>
                    {{ comparedResponseData.incentivesAmount_visits }}
                  </span>
                  <span
                    class="compareValues_icon"
                    [class.compareValues_icon_negative]="
                      comparedResponseData.incentivesAmount_visits_color == 1
                    "
                    [class.compareValues_icon_positive]="
                      comparedResponseData.incentivesAmount_visits_color == 2
                    "
                  >
                  </span>
                </p>
              </div>
              <div class="performance-box-orders_table-item width70">
                <p class="compareValues">
                  <span>
                    {{ comparedResponseData.controlAmount_visits }}
                  </span>
                  <span
                    class="compareValues_icon"
                    [class.compareValues_icon_negative]="
                      comparedResponseData.controlAmount_visits_color == 1
                    "
                    [class.compareValues_icon_positive]="
                      comparedResponseData.controlAmount_visits_color == 2
                    "
                  >
                  </span>
                </p>
              </div>
              <div class="performance-box-orders_table-item">
                <p class="compareValues" style="white-space: nowrap">
                  <span>
                    {{ comparedResponseData.revUplift | currencyFormatter }}
                  </span>
                  <span
                    class="compareValues_icon"
                    [class.compareValues_icon_negative]="
                      comparedResponseData.revUplift_color == 1
                    "
                    [class.compareValues_icon_positive]="
                      comparedResponseData.revUplift_color == 2
                    "
                  >
                  </span>
                </p>
              </div>
            </div>
            <ng-container *ngIf="!raisinInvestmentViewSelected">
              <div class="performance-box-orders_table-row">
                <div class="performance-box-orders_table-item width80">
                  <p>{{ "words.orders" | translate }}</p>
                </div>
                <div class="performance-box-orders_table-item width120">
                  <p>
                    {{
                      incentiveBarChart.crorderAmount.incentivesAmount.orders
                    }}
                  </p>
                </div>
                <div
                  class="performance-box-orders_table-item width70"
                  *ngIf="!nudgeLite"
                >
                  <p>
                    {{ incentiveBarChart.crorderAmount.controlAmount.orders }}
                  </p>
                </div>
                <div class="performance-box-orders_table-item">
                  <p></p>
                </div>
              </div>
              <div
                class="performance-box-orders_table-row"
                *ngIf="compareObject.isActive"
              >
                <div class="performance-box-orders_table-item width80">
                  <p
                    matTooltip="{{
                      'phrases.previous_period_orders' | translate
                    }}"
                    matTooltipPosition="above"
                    style="opacity: 0.5"
                  >
                    {{ ("words.compared" | translate) + ":" }}
                  </p>
                </div>
                <div class="performance-box-orders_table-item width120">
                  <p class="compareValues">
                    <span>
                      {{ comparedResponseData.incentivesAmount_orders }}
                    </span>
                    <span
                      class="compareValues_icon"
                      [class.compareValues_icon_negative]="
                        comparedResponseData.incentivesAmount_orders_color == 1
                      "
                      [class.compareValues_icon_positive]="
                        comparedResponseData.incentivesAmount_orders_color == 2
                      "
                    >
                    </span>
                  </p>
                </div>
                <div class="performance-box-orders_table-item width70">
                  <p class="compareValues">
                    <span>
                      {{ comparedResponseData.controlAmount_orders }}
                    </span>
                    <span
                      class="compareValues_icon"
                      [class.compareValues_icon_negative]="
                        comparedResponseData.controlAmount_orders_color == 1
                      "
                      [class.compareValues_icon_positive]="
                        comparedResponseData.controlAmount_orders_color == 2
                      "
                    >
                    </span>
                  </p>
                </div>
                <div class="performance-box-orders_table-item">
                  <p></p>
                </div>
              </div>
              <div
                class="performance-box-orders_table-row"
                *ngIf="isBehamicsUser"
              >
                <div class="performance-box-orders_table-item width80">
                  <p>Split</p>
                </div>
                <div class="performance-box-orders_table-item width120">
                  <p>{{ globalControlRates().nudge }}%</p>
                </div>
                <div class="performance-box-orders_table-item width70">
                  <p>{{ globalControlRates().control }}%</p>
                </div>
                <div class="performance-box-orders_table-item">
                  <p></p>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="raisinInvestmentViewSelected">
              <div class="performance-box-orders_table-row">
                <div class="performance-box-orders_table-item width80">
                  <p
                    matTooltip="R Investments are the investments that happened from the registrations made during the selected timeframe."
                    matTooltipPosition="above"
                  >
                    R Investments
                  </p>
                </div>
                <div class="performance-box-orders_table-item width120">
                  <p>
                    {{ investmentDashboardData?.nudge?.timeframeInvestments }}
                  </p>
                </div>
                <div
                  class="performance-box-orders_table-item width70"
                  *ngIf="!nudgeLite"
                >
                  <p>
                    {{ investmentDashboardData?.control?.timeframeInvestments }}
                  </p>
                </div>
                <div class="performance-box-orders_table-item">
                  <p></p>
                </div>
              </div>
              <div class="performance-box-orders_table-row">
                <div class="performance-box-orders_table-item width80">
                  <p
                    matTooltip="A Investments are all investments that happened during the selected timeframe, including those from previous registrations."
                    matTooltipPosition="above"
                  >
                    A Investments
                  </p>
                </div>
                <div class="performance-box-orders_table-item width120">
                  <p>
                    {{ investmentDashboardData?.nudge?.totalInvestments }}
                  </p>
                </div>
                <div
                  class="performance-box-orders_table-item width70"
                  *ngIf="!nudgeLite"
                >
                  <p>
                    {{ investmentDashboardData?.control?.totalInvestments }}
                  </p>
                </div>
                <div class="performance-box-orders_table-item">
                  <p></p>
                </div>
              </div>
              <div
                class="performance-box-orders_table-row"
                *ngIf="compareObject.isActive"
              >
                <div class="performance-box-orders_table-item width80">
                  <p
                    matTooltip="{{
                      'phrases.previous_period_orders' | translate
                    }}"
                    matTooltipPosition="above"
                    style="opacity: 0.5"
                  >
                    {{ ("words.compared" | translate) + ":" }}
                  </p>
                </div>
                <div class="performance-box-orders_table-item width120">
                  <p class="compareValues">
                    <span>
                      {{ comparedResponseData.investment }}
                    </span>
                    <span
                      class="compareValues_icon"
                      [class.compareValues_icon_negative]="
                        comparedResponseData.investment_color == 1
                      "
                      [class.compareValues_icon_positive]="
                        comparedResponseData.investment_color == 2
                      "
                    >
                    </span>
                  </p>
                </div>
                <div class="performance-box-orders_table-item width70">
                  <p class="compareValues">
                    <span>
                      {{ comparedResponseData.investment_control }}
                    </span>
                    <span
                      class="compareValues_icon"
                      [class.compareValues_icon_negative]="
                        comparedResponseData.investment_control_color == 1
                      "
                      [class.compareValues_icon_positive]="
                        comparedResponseData.investment_control_color == 2
                      "
                    >
                    </span>
                  </p>
                </div>
                <div class="performance-box-orders_table-item">
                  <p></p>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div
          class="performance-box-orders_content-divider"
          *ngIf="!nudgeLite && !raisinInvestmentViewSelected"
        ></div>
        <div
          class="performance-box-orders_headless_table"
          *ngIf="!raisinInvestmentViewSelected"
        >
          <div
            class="performance-box-orders_headless_table-item"
            *ngIf="!nudgeLite"
          >
            <div class="performance-box-orders_table-item">
              <p>
                <b>{{ "phrases.share_of_total_revenue" | translate }}</b>
              </p>
            </div>
            <p class="performance-box-orders_headless_table-value">
              {{ formatPercentage(this.totalInfo.share.revenueShare) }}
            </p>
            <p
              *ngIf="compareObject.isActive"
              class="performance-box-orders_headless_table-value compareValues"
            >
              <span>
                {{ formatPercentage(comparedResponseData.share_revenueShare) }}
              </span>
              <span
                class="compareValues_icon"
                [class.compareValues_icon_negative]="
                  comparedResponseData.share_revenueShare_color == 1
                "
                [class.compareValues_icon_positive]="
                  comparedResponseData.share_revenueShare_color == 2
                "
              >
              </span>
            </p>
            <div class="rev-share-hidden">
              <p>
                {{ "phrases.the_share_of_total_revenue" | translate }}
              </p>
              <p>
                <span
                  [ngClass]="{
                    'uplift-green': checkUpliftColor(this.revUplift) === true,
                    'uplift-red': checkUpliftColor(this.revUplift) === false,
                    'uplift-none': checkUpliftColor(this.revUplift) === 0,
                  }"
                  >{{ formatNumber(this.revUplift) }}</span
                >
                /
                {{
                  this.isNaN(this.totalInfo.total.totalRevenue)
                    ? 0
                    : this.totalInfo.total.totalRevenue
                }}
                =
                {{ this.getFormattedValue(this.totalInfo.share.revenueShare) }}
              </p>
            </div>
          </div>
          <div
            class="performance-box-orders_headless_table-item"
            *ngIf="!nudgeLite"
          >
            <div class="performance-box-orders_table-item">
              <p>
                <b>{{ "phrases.share_of_traffic" | translate }}</b>
              </p>
            </div>
            <p class="performance-box-orders_headless_table-value">
              {{ formatPercentage(this.totalInfo.share.trafficShare) }}
            </p>
            <p
              class="performance-box-orders_headless_table-value compareValues"
              *ngIf="compareObject.isActive"
            >
              <span>
                {{ formatPercentage(comparedResponseData.share_trafficShare) }}
              </span>
              <span
                class="compareValues_icon"
                [class.compareValues_icon_negative]="
                  comparedResponseData.share_trafficShare_color == 1
                "
                [class.compareValues_icon_positive]="
                  comparedResponseData.share_trafficShare_color == 2
                "
              >
              </span>
            </p>
            <div class="rev-share-hidden">
              <p>
                {{ "phrases.the_share_of_traffic" | translate }}
              </p>
              <p>
                {{
                  this.safeSum(
                    this.totalInfo.difference.visitsIncentive,
                    this.totalInfo.difference.visitsControl
                  )
                }}
                /
                {{
                  this.safeSum(
                    this.totalInfo.difference.v,
                    this.totalInfo.difference.vgc
                  )
                }}
                =
                {{ this.getTrafficShare() }}
              </p>
            </div>
          </div>
          <div
            class="performance-box-orders_headless_table-item"
            *ngIf="!nudgeLite"
          >
            <div class="performance-box-orders_table-item">
              <p>
                <b>{{ "phrases.share_of_orders" | translate }}</b>
              </p>
            </div>
            <p class="performance-box-orders_headless_table-value">
              {{ formatPercentage(this.totalInfo.share.ordersShare) }}
            </p>
            <p
              class="performance-box-orders_headless_table-value compareValues"
              *ngIf="compareObject.isActive"
            >
              <span>
                {{ formatPercentage(comparedResponseData.share_ordersShare) }}
              </span>
              <span
                class="compareValues_icon"
                [class.compareValues_icon_negative]="
                  comparedResponseData.share_ordersShare_color == 1
                "
                [class.compareValues_icon_positive]="
                  comparedResponseData.share_ordersShare_color == 2
                "
              >
              </span>
            </p>
            <div class="rev-share-hidden">
              <p>
                {{ "phrases.the_share_of_orders" | translate }}
              </p>
              <p>
                {{
                  this.safeSum(
                    this.totalInfo.difference.ordersIncentive,
                    this.totalInfo.difference.ordersControl
                  )
                }}
                /
                {{
                  this.safeSum(
                    this.totalInfo.difference.o,
                    this.totalInfo.difference.ogc
                  )
                }}
                =
                {{ this.getOrdersShare() }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="deviation-borders-toogle-container"
          *ngIf="showDeviationBorderToogle && !raisinInvestmentViewSelected"
        >
          <p>{{ "phrases.error_bar" | translate }}</p>
          <mat-slide-toggle
            class="example-margin"
            [(ngModel)]="toogleDeviationBorders"
          >
          </mat-slide-toggle>
        </div>
      </ng-container>
    </div>

    <div class="skeleton-lines" *ngIf="!firstLoader">
      <ngx-skeleton-loader
        count="3"
        [theme]="{
          height: '18px',
          outline: 'none',
          'background-color': '#37474f1a',
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>

  <div class="sq-title-loader" *ngIf="!firstLoader">
    <div fxFlex.gt-sm="33" fxFlex.gt-xs="50" fxFlex="100">
      <div class="skeleton-title-squares">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '20px',
            outline: 'none',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="skeleton-box-square">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '290px',
            outline: 'none',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div fxFlex.gt-sm="33" fxFlex.gt-xs="50" fxFlex="100">
      <div class="skeleton-title-squares">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '20px',
            outline: 'none',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="skeleton-box-square">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '290px',
            outline: 'none',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div fxFlex.gt-sm="33" fxFlex.gt-xs="50" fxFlex="100">
      <div class="skeleton-title-squares">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '20px',
            outline: 'none',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="skeleton-box-square">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '290px',
            outline: 'none',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>

  <div
    class="pov-bar-charts-holder"
    *ngIf="firstLoader"
    [ngClass]="{
      nudgeLite: nudgeLite,
    }"
  >
    <div class="pov-pageBarChart-container">
      <div class="pov-pageBarChart-axis">
        <h5>{{ "words.cr" | translate }}</h5>
        <div
          class="pov-pageBarChart-axis-inner"
          *ngFor="let axis of barChartCrAxis"
        >
          <p>{{ axis }}%</p>
        </div>
      </div>
      <div class="pov-pageBarChart-main">
        <div
          class="pov-pageBarChart-main-charts"
          *ngFor="let bar of barChartCr; let i = index"
          [ngClass]="{
            controlBar: bar.control,
          }"
        >
          <div
            class="pov-pageBarChart-main-charts-bar-container"
            [class.low_value_bar]="bar.height < 20 && bar.value != 0"
          >
            <div
              class="pov-pageBarChart-main-charts-bar"
              [ngClass]="{
                defaultCol: bar.control,
              }"
              [ngStyle]="{ height: bar.height + '%' }"
            >
              <div
                [ngClass]="{
                  zeroBarVal: bar.value == 0,
                  top_position:
                    bar?.default?.negative && toogleDeviationBorders,
                }"
                class="pov-pageBarChart-main-charts-bar-innervalue"
              >
                <div>{{ bar.value }}%</div>
                <div *ngIf="!bar.control && bar.diff && !nudgeLite">
                  ({{ bar.diff }})
                </div>
              </div>
              <div
                class="pov-pageBarChart-main-charts-bar-tooltip"
                *ngIf="bar.tooltip_translate && !nudgeLite"
              >
                <b>{{ ("phrases.sig_control" | translate) + ":" }}</b>
                {{
                  "phrases.score_with_label"
                    | translate
                      : {
                          value: bar.tooltip_translate?.score,
                          label: (bar.tooltip_translate?.label | translate),
                        }
                }}
              </div>
            </div>

            <!-- default line -->
            <div
              class="pov-default-line_deviation"
              *ngIf="bar?.default && toogleDeviationBorders"
              [ngStyle]="{
                height: bar?.default?.height + '%',
                bottom: bar?.default?.bottom + '%',
              }"
              [ngClass]="{ negative: bar?.default?.negative }"
            ></div>
          </div>
          <div class="pov-pageBarChart-main-charts-name">
            <p>{{ bar.name | translate }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="pov-pageBarChart-container">
      <div class="pov-pageBarChart-axis">
        <h5>{{ "words.rpv" | translate }}</h5>
        <div
          class="pov-pageBarChart-axis-inner"
          *ngFor="let axis of barChartRpvAxis"
        >
          <p>{{ axis | currencyFormatter }}</p>
        </div>
      </div>
      <div class="pov-pageBarChart-main">
        <div
          class="pov-pageBarChart-main-charts"
          *ngFor="let bar of barChartRpv; let i = index"
          [ngClass]="{
            controlBar: bar.control,
          }"
        >
          <div
            class="pov-pageBarChart-main-charts-bar-container"
            [class.low_value_bar]="bar.height < 20 && bar.value != 0"
          >
            <div
              class="pov-pageBarChart-main-charts-bar"
              [ngClass]="{
                defaultCol: bar.control,
              }"
              [ngStyle]="{ height: bar.height + '%' }"
            >
              <div
                [ngClass]="{
                  zeroBarVal: bar.value == 0,
                  top_position:
                    bar?.default?.negative && toogleDeviationBorders,
                }"
                class="pov-pageBarChart-main-charts-bar-innervalue"
              >
                {{ bar.value | currencyFormatter }}
                <div *ngIf="!bar.control && bar.diff && !nudgeLite">
                  ({{ bar.diff }})
                </div>
              </div>

              <div
                class="pov-pageBarChart-main-charts-bar-tooltip"
                *ngIf="bar.tooltip_translate && !nudgeLite"
              >
                <b>{{ ("phrases.sig_control" | translate) + ":" }}</b>
                {{
                  "phrases.score_with_label"
                    | translate
                      : {
                          value: bar.tooltip_translate?.score,
                          label: (bar.tooltip_translate?.label | translate),
                        }
                }}
              </div>
            </div>

            <!-- default line -->
            <div
              class="pov-default-line_deviation"
              *ngIf="bar?.default && toogleDeviationBorders"
              [ngStyle]="{
                height: bar?.default?.height + '%',
                bottom: bar?.default?.bottom + '%',
              }"
              [ngClass]="{ negative: bar?.default?.negative }"
            ></div>
          </div>
          <div class="pov-pageBarChart-main-charts-name">
            <p>{{ bar.name | translate }}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="pov-pageBarChart-container"
      *ngIf="raisinInvestmentViewSelected"
    >
      <div class="pov-pageBarChart-axis">
        <h5>RPR</h5>
        <div
          class="pov-pageBarChart-axis-inner"
          *ngFor="let axis of barChartRprAxis"
        >
          <p>{{ axis | currencyFormatter }}</p>
        </div>
      </div>
      <div class="pov-pageBarChart-main">
        <div
          class="pov-pageBarChart-main-charts"
          *ngFor="let bar of barChartRpr; let i = index"
          [ngClass]="{
            controlBar: bar.control,
          }"
        >
          <div
            class="pov-pageBarChart-main-charts-bar-container"
            [class.low_value_bar]="bar.height < 20 && bar.value != 0"
          >
            <div
              class="pov-pageBarChart-main-charts-bar"
              [ngClass]="{
                defaultCol: bar.control,
              }"
              [ngStyle]="{ height: bar.height + '%' }"
            >
              <div
                [ngClass]="{
                  zeroBarVal: bar.value == 0,
                  top_position:
                    bar?.default?.negative && toogleDeviationBorders,
                }"
                class="pov-pageBarChart-main-charts-bar-innervalue"
              >
                {{ bar.value | currencyFormatter }}
                <div *ngIf="bar.name != 'Control' && bar.diff && !nudgeLite">
                  ({{ bar.diff }})
                </div>
              </div>
              <div
                class="pov-pageBarChart-main-charts-bar-tooltip"
                *ngIf="bar.tooltip_translate && !nudgeLite"
              >
                <b>{{ ("phrases.sig_control" | translate) + ":" }}</b>
                {{
                  "phrases.score_with_label"
                    | translate
                      : {
                          value: bar.tooltip_translate?.score,
                          label: (bar.tooltip_translate?.label | translate),
                        }
                }}
              </div>
            </div>

            <!-- default line -->
            <div
              class="pov-default-line_deviation"
              *ngIf="bar?.default && toogleDeviationBorders"
              [ngStyle]="{
                height: bar?.default?.height + '%',
                bottom: bar?.default?.bottom + '%',
              }"
              [ngClass]="{ negative: bar?.default?.negative }"
            ></div>
          </div>
          <div class="pov-pageBarChart-main-charts-name">
            <p>{{ bar.name | translate }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="pov-pageBarChart-container">
      <div class="pov-pageBarChart-axis">
        <h5>{{ "words.aov" | translate }}</h5>
        <div
          class="pov-pageBarChart-axis-inner"
          *ngFor="let axis of barChartAovAxis"
        >
          <p>{{ axis | currencyFormatter }}</p>
        </div>
      </div>
      <div class="pov-pageBarChart-main">
        <div
          class="pov-pageBarChart-main-charts"
          *ngFor="let bar of barChartAov; let i = index"
          [ngClass]="{
            controlBar: bar.control,
          }"
        >
          <div
            class="pov-pageBarChart-main-charts-bar-container"
            [class.low_value_bar]="bar.height < 20 && bar.value != 0"
          >
            <div
              class="pov-pageBarChart-main-charts-bar"
              [ngClass]="{
                defaultCol: bar.control,
              }"
              [ngStyle]="{ height: bar.height + '%' }"
            >
              <div
                [ngClass]="{
                  zeroBarVal: bar.value == 0,
                  top_position:
                    bar?.default?.negative && toogleDeviationBorders,
                }"
                class="pov-pageBarChart-main-charts-bar-innervalue"
              >
                {{ bar.value | currencyFormatter }}
                <div *ngIf="bar.name != 'Control' && bar.diff && !nudgeLite">
                  ({{ bar.diff }})
                </div>
              </div>
              <div
                class="pov-pageBarChart-main-charts-bar-tooltip"
                *ngIf="bar.tooltip_translate && !nudgeLite"
              >
                <b>{{ ("phrases.sig_control" | translate) + ":" }}</b>
                {{
                  "phrases.score_with_label"
                    | translate
                      : {
                          value: bar.tooltip_translate?.score,
                          label: (bar.tooltip_translate?.label | translate),
                        }
                }}
              </div>
            </div>

            <!-- default line -->
            <div
              class="pov-default-line_deviation"
              *ngIf="bar?.default && toogleDeviationBorders"
              [ngStyle]="{
                height: bar?.default?.height + '%',
                bottom: bar?.default?.bottom + '%',
              }"
              [ngClass]="{ negative: bar?.default?.negative }"
            ></div>
          </div>
          <div class="pov-pageBarChart-main-charts-name">
            <p>{{ bar.name | translate }}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="pov-pageBarChart-container"
      *ngIf="
        showATRBarchart &&
        barChartAtrAxis &&
        barChartAtrAxis?.length > 0 &&
        !demoAccountForTarget &&
        !raisinInvestmentViewSelected
      "
    >
      <div class="pov-pageBarChart-axis">
        <h5>{{ "words.atr" | translate }}</h5>
        <div
          class="pov-pageBarChart-axis-inner"
          *ngFor="let axis of barChartAtrAxis"
        >
          <p>{{ axis }}%</p>
        </div>
      </div>

      <div class="pov-pageBarChart-main">
        <div
          class="pov-pageBarChart-main-charts"
          *ngFor="let bar of barChartAtr; let i = index"
          [ngClass]="{
            controlBar: bar.control,
          }"
        >
          <div
            class="pov-pageBarChart-main-charts-bar-container"
            [class.low_value_bar]="bar.height < 20 && bar.value != 0"
          >
            <div
              class="pov-pageBarChart-main-charts-bar"
              [ngClass]="{
                defaultCol: bar.control,
              }"
              [ngStyle]="{ height: bar.height + '%' }"
            >
              <div
                [ngClass]="{ zeroBarVal: bar.value == 0 }"
                class="pov-pageBarChart-main-charts-bar-innervalue"
              >
                <div>{{ bar.value }}%</div>
                <div *ngIf="!bar.control && bar.diff && !nudgeLite">
                  ({{ bar.diff }})
                </div>
              </div>
              <div
                class="pov-pageBarChart-main-charts-bar-tooltip"
                *ngIf="bar.tooltip_translate && !nudgeLite"
              >
                <b>{{ ("phrases.sig_control" | translate) + ":" }}</b>
                {{
                  "phrases.score_with_label"
                    | translate
                      : {
                          value: bar.tooltip_translate?.score,
                          label: (bar.tooltip_translate?.label | translate),
                        }
                }}
              </div>
            </div>
          </div>
          <div class="pov-pageBarChart-main-charts-name">
            <p>{{ bar.name | translate }}</p>
          </div>
        </div>
      </div>

      <div class="loading-data-overlay" *ngIf="atrBarChartLoader">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    </div>
    <div class="pov-pageBarChart-container" *ngIf="!receivedInfoRrNull">
      <div class="pov-pageBarChart-axis">
        <h5>{{ "words.rr" | translate }}</h5>
        <div
          class="pov-pageBarChart-axis-inner"
          *ngFor="let axis of barChartRRAxis"
        >
          <p>{{ axis }}%</p>
        </div>
      </div>
      <div class="pov-pageBarChart-main">
        <div
          class="pov-pageBarChart-main-charts"
          *ngFor="let bar of barChartRR; let i = index"
        >
          <div
            class="pov-pageBarChart-main-charts-bar-container"
            [class.low_value_bar]="bar.height < 20 && bar.value != 0"
          >
            <div
              class="pov-pageBarChart-main-charts-bar"
              [ngClass]="{
                defaultCol: bar.control,
              }"
              [ngStyle]="{ height: bar.height + '%' }"
            >
              <div
                [ngClass]="{ zeroBarVal: bar.value == 0 }"
                class="pov-pageBarChart-main-charts-bar-innervalue"
              >
                {{ bar.value }}%
                <div *ngIf="bar.name != 'Control'">({{ bar.diff }})</div>
              </div>
              <div
                class="pov-pageBarChart-main-charts-bar-tooltip"
                *ngIf="bar.tooltip_translate"
              >
                <b>{{ ("phrases.sig_control" | translate) + ":" }}</b>
                {{
                  "phrases.score_with_label"
                    | translate
                      : {
                          value: bar.tooltip_translate?.score,
                          label: (bar.tooltip_translate?.label | translate),
                        }
                }}
              </div>
            </div>
          </div>
          <div class="pov-pageBarChart-main-charts-name">
            <p>{{ bar.name | translate }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="pov-pageBarChart-container" *ngIf="!receivedInfoNrNull">
      <div class="pov-pageBarChart-axis">
        <h5>{{ "words.nr" | translate }}</h5>
        <div
          class="pov-pageBarChart-axis-inner"
          *ngFor="let axis of barChartNRAxis"
        >
          <p>{{ axis | currencyFormatter }}</p>
        </div>
      </div>
      <div class="pov-pageBarChart-main">
        <div
          class="pov-pageBarChart-main-charts"
          *ngFor="let bar of barChartNR; let i = index"
        >
          <div
            class="pov-pageBarChart-main-charts-bar-container"
            [class.low_value_bar]="bar.height < 20 && bar.value != 0"
          >
            <div
              class="pov-pageBarChart-main-charts-bar"
              [ngClass]="{
                defaultCol: bar.control,
              }"
              [ngStyle]="{ height: bar.height + '%' }"
            >
              <div
                [ngClass]="{ zeroBarVal: bar.value == 0 }"
                class="pov-pageBarChart-main-charts-bar-innervalue"
              >
                {{ bar.value | currencyFormatter }}
                <div *ngIf="bar.name != 'Control'">({{ bar.diff }})</div>
              </div>
              <div
                class="pov-pageBarChart-main-charts-bar-tooltip"
                *ngIf="bar.tooltip_translate"
              >
                <b>{{ ("phrases.sig_control" | translate) + ":" }}</b>
                {{
                  "phrases.score_with_label"
                    | translate
                      : {
                          value: bar.tooltip_translate?.score,
                          label: (bar.tooltip_translate?.label | translate),
                        }
                }}
              </div>
            </div>
          </div>
          <div class="pov-pageBarChart-main-charts-name">
            <p>{{ bar.name | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  fxLayout="row"
  fxLayout.xs="column"
  fxLayout.sm="column"
  fxLayoutGap="10px"
  *ngIf="nudgeLite"
>
  <ng-container *ngIf="showNudgeLiteNewData">
    <div class="dtpickerall" *ngIf="firstLoader">
      <div
        class="master_longitudinal_main-header master_performance_main-header"
      >
        <mat-form-field
          class="bhm-option-container-1"
          style="
            --label-name: '{{ 'words.device' | translate }}:';
            --form-field-infix-width: 140px;
          "
        >
          <mat-select
            (selectionChange)="selectionDeviceChanged($event)"
            [(ngModel)]="incentiveBarChart.selectedPlatform"
          >
            <mat-option class="bhm-option-select-option-1" value="overall">
              {{ "words.overall" | translate }}
            </mat-option>
            <mat-option class="bhm-option-select-option-1" value="desktop">
              {{ "words.desktop" | translate }}
            </mat-option>
            <mat-option class="bhm-option-select-option-1" value="tablet">
              {{ "words.tablet" | translate }}
            </mat-option>
            <mat-option class="bhm-option-select-option-1" value="mobile">
              {{ "words.mobile" | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          class="bhm-option-container-1"
          style="
            --label-name: '{{ 'words.visits' | translate }}:';
            --form-field-infix-width: 160px;
          "
        >
          <mat-select
            (selectionChange)="filterVisits($event)"
            [value]="incentiveBarChart.selectedFilter"
          >
            <mat-option class="bhm-option-select-option-1" value="overall">
              {{ "words.overall" | translate }}
            </mat-option>
            <mat-option class="bhm-option-select-option-1" value="newVisit">
              {{ "phrases.new_visits" | translate }}
            </mat-option>
            <mat-option
              class="bhm-option-select-option-1"
              value="returningVisit"
            >
              {{ "phrases.returning_visits" | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="sidebtn-action-holder">
          <button
            mat-button
            class="btn_withoutIcon custom-button"
            [disabled]="rawDataButtonDisabled"
            (click)="generateRawData()"
          >
            <span style="margin-right: 3px; top: -1px; position: relative">
              {{
                rawDataButtonDisabled
                  ? ("words.processing" | translate) + "..."
                  : ("phrases.raw_data" | translate)
              }}
            </span>
            <svg
              class="button_download_icon"
              style="width: 13px; position: relative; top: 1px"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title></title>
              <g id="Complete">
                <g id="download">
                  <g>
                    <path
                      d="M3,12.3v7a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-7"
                      fill="none"
                      stroke="var(--text-main-color)"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    ></path>
                    <g>
                      <polyline
                        data-name="Right"
                        fill="none"
                        id="Right-2"
                        points="7.9 12.3 12 16.3 16.1 12.3"
                        stroke="var(--text-main-color)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      ></polyline>
                      <line
                        fill="none"
                        stroke="var(--text-main-color)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        x1="12"
                        x2="12"
                        y1="2.7"
                        y2="14.2"
                      ></line>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <button
            mat-button
            (click)="generateReport('report')"
            [disabled]="this.daysDifference <= 1"
            class="btn_withoutIcon custom-button"
          >
            <span style="margin-right: 3px; top: -1px; position: relative">
              {{ "words.report" | translate }}
            </span>
            <svg
              class="button_download_icon"
              style="width: 13px; position: relative; top: 1px"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title></title>
              <g id="Complete">
                <g id="download">
                  <g>
                    <path
                      d="M3,12.3v7a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-7"
                      fill="none"
                      stroke="var(--text-main-color)"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    ></path>
                    <g>
                      <polyline
                        data-name="Right"
                        fill="none"
                        id="Right-2"
                        points="7.9 12.3 12 16.3 16.1 12.3"
                        stroke="var(--text-main-color)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      ></polyline>
                      <line
                        fill="none"
                        stroke="var(--text-main-color)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        x1="12"
                        x2="12"
                        y1="2.7"
                        y2="14.2"
                      ></line>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div id="overall-card" style="width: 100%; flex-direction: column">
      <div
        class="ordersamount-container"
        fxFlex.gt-sm="100"
        fxFlex.gt-xs="100"
        fxFlex="100"
      >
        <div class="performance-box-orders_content">
          <ng-container *ngIf="firstLoader">
            <div class="performance-box-orders_table">
              <div class="performance-box-orders_table-header">
                <div class="performance-box-orders_table-item width80">
                  <p></p>
                </div>
                <div class="performance-box-orders_table-item width120">
                  <p
                    matTooltip="{{
                      'phrases.visits_who_have_seen_at_least_one_nudge'
                        | translate
                    }}"
                    matTooltipPosition="above"
                  >
                    {{
                      isChewyTarget
                        ? ("phrases.test_overall" | translate)
                        : ("phrases.nudges_overall" | translate)
                    }}
                  </p>
                </div>
              </div>
              <div class="performance-box-orders_table-body">
                <div class="performance-box-orders_table-row">
                  <div class="performance-box-orders_table-item width80">
                    <p
                      matTooltip="{{ 'phrases.visit_definition' | translate }}"
                      matTooltipPosition="above"
                    >
                      {{ "words.visits" | translate }}
                    </p>
                  </div>
                  <div class="performance-box-orders_table-item width120">
                    <p>
                      {{
                        incentiveBarChart.crorderAmount.incentivesAmount.visits
                      }}
                    </p>
                  </div>
                </div>
                <div
                  class="performance-box-orders_table-row"
                  *ngIf="compareObject.isActive"
                >
                  <div class="performance-box-orders_table-item width80">
                    <p
                      matTooltip="{{
                        'phrases.previous_period_visits' | translate
                      }}"
                      matTooltipPosition="above"
                      style="opacity: 0.5"
                    >
                      {{ ("words.compared" | translate) + ":" }}
                    </p>
                  </div>
                  <div class="performance-box-orders_table-item width120">
                    <p class="compareValues">
                      <span>
                        {{ comparedResponseData.incentivesAmount_visits }}
                      </span>
                      <span
                        class="compareValues_icon"
                        [class.compareValues_icon_negative]="
                          comparedResponseData.incentivesAmount_visits_color ==
                          1
                        "
                        [class.compareValues_icon_positive]="
                          comparedResponseData.incentivesAmount_visits_color ==
                          2
                        "
                      >
                      </span>
                    </p>
                  </div>
                </div>
                <div class="performance-box-orders_table-row">
                  <div class="performance-box-orders_table-item width80">
                    <p>{{ "words.orders" | translate }}</p>
                  </div>
                  <div class="performance-box-orders_table-item width120">
                    <p>
                      {{
                        incentiveBarChart.crorderAmount.incentivesAmount.orders
                      }}
                    </p>
                  </div>
                </div>
                <div
                  class="performance-box-orders_table-row"
                  *ngIf="compareObject.isActive"
                >
                  <div class="performance-box-orders_table-item width80">
                    <p
                      matTooltip="{{
                        'phrases.previous_period_orders' | translate
                      }}"
                      matTooltipPosition="above"
                      style="opacity: 0.5"
                    >
                      {{ ("words.compared" | translate) + ":" }}
                    </p>
                  </div>
                  <div class="performance-box-orders_table-item width120">
                    <p class="compareValues">
                      <span>
                        {{ comparedResponseData.incentivesAmount_orders }}
                      </span>
                      <span
                        class="compareValues_icon"
                        [class.compareValues_icon_negative]="
                          comparedResponseData.incentivesAmount_orders_color ==
                          1
                        "
                        [class.compareValues_icon_positive]="
                          comparedResponseData.incentivesAmount_orders_color ==
                          2
                        "
                      >
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="performance-box-orders_content-divider"></div>
            <div class="performance-box-orders_headless_table">
              <div class="performance-box-orders_headless_table-item">
                <div class="performance-box-orders_table-item">
                  <p>
                    <b>{{ "phrases.share_of_traffic" | translate }}</b>
                  </p>
                </div>
                <p class="performance-box-orders_headless_table-value">
                  {{ formatPercentage(this.totalInfo.share.trafficShare) }}
                </p>
                <p
                  class="performance-box-orders_headless_table-value compareValues"
                  *ngIf="compareObject.isActive"
                >
                  <span>
                    {{
                      formatPercentage(comparedResponseData.share_trafficShare)
                    }}
                  </span>
                  <span
                    class="compareValues_icon"
                    [class.compareValues_icon_negative]="
                      comparedResponseData.share_trafficShare_color == 1
                    "
                    [class.compareValues_icon_positive]="
                      comparedResponseData.share_trafficShare_color == 2
                    "
                  >
                  </span>
                </p>
                <div class="rev-share-hidden">
                  <p>
                    {{ "phrases.the_share_of_traffic" | translate }}
                  </p>
                  <p>
                    {{
                      this.safeSum(
                        this.totalInfo.difference.visitsIncentive,
                        this.totalInfo.difference.visitsControl
                      )
                    }}
                    /
                    {{
                      this.safeSum(
                        this.totalInfo.difference.v,
                        this.totalInfo.difference.vgc
                      )
                    }}
                    =
                    {{ this.getTrafficShare() }}
                  </p>
                </div>
              </div>
              <div class="performance-box-orders_headless_table-item">
                <div class="performance-box-orders_table-item">
                  <p>
                    <b>{{ "phrases.share_of_orders" | translate }}</b>
                  </p>
                </div>
                <p class="performance-box-orders_headless_table-value">
                  {{ formatPercentage(this.totalInfo.share.ordersShare) }}
                </p>
                <p
                  class="performance-box-orders_headless_table-value compareValues"
                  *ngIf="compareObject.isActive"
                >
                  <span>
                    {{
                      formatPercentage(comparedResponseData.share_ordersShare)
                    }}
                  </span>
                  <span
                    class="compareValues_icon"
                    [class.compareValues_icon_negative]="
                      comparedResponseData.share_ordersShare_color == 1
                    "
                    [class.compareValues_icon_positive]="
                      comparedResponseData.share_ordersShare_color == 2
                    "
                  >
                  </span>
                </p>
                <div class="rev-share-hidden">
                  <p>
                    {{ "phrases.the_share_of_orders" | translate }}
                  </p>
                  <p>
                    {{
                      this.safeSum(
                        this.totalInfo.difference.ordersIncentive,
                        this.totalInfo.difference.ordersControl
                      )
                    }}
                    /
                    {{
                      this.safeSum(
                        this.totalInfo.difference.o,
                        this.totalInfo.difference.ogc
                      )
                    }}
                    =
                    {{ this.getOrdersShare() }}
                  </p>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="skeleton-lines" *ngIf="!firstLoader">
          <ngx-skeleton-loader
            count="3"
            [theme]="{
              height: '18px',
              outline: 'none',
              'background-color': '#37474f1a',
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>

      <div class="sq-title-loader" *ngIf="!firstLoader">
        <div fxFlex.gt-sm="33" fxFlex.gt-xs="50" fxFlex="100">
          <div class="skeleton-title-squares">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '20px',
                outline: 'none',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div class="skeleton-box-square">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '290px',
                outline: 'none',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>
        <div fxFlex.gt-sm="33" fxFlex.gt-xs="50" fxFlex="100">
          <div class="skeleton-title-squares">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '20px',
                outline: 'none',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div class="skeleton-box-square">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '290px',
                outline: 'none',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>
        <div fxFlex.gt-sm="33" fxFlex.gt-xs="50" fxFlex="100">
          <div class="skeleton-title-squares">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '20px',
                outline: 'none',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div class="skeleton-box-square">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '290px',
                outline: 'none',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div
    class="full-width"
    fxLayout="row wrap"
    style="margin-top: 40px; padding: 0px 0px"
  >
    <div class="gene-card-title" *ngIf="firstLoader">
      <div
        class="nudge-analytics-header"
        style="
          display: flex;
          align-items: center;
          gap: 20px;
          margin-bottom: 10px;
        "
      >
        <h5 style="font-size: 16px; margin: 0px; color: #383838">
          {{
            isChewyTarget
              ? ("phrases.test_analytics" | translate)
              : ("phrases.nudge_analytics" | translate)
          }}
        </h5>
        <button
          class="custom-button custom-button_clear-filters"
          mat-raised-button
          type="button"
          (click)="clearFilters(incentivesChartTitle, incentivesLineChart)"
          *ngIf="showClearFilter(incentivesChartTitle)"
        >
          <span> {{ "phrases.clear_filters" | translate }} </span>
        </button>

        <mat-form-field
          class="bhm-option-container-1"
          style="
              --label-name: '{{ 'words.rate' | translate }}:';
              --form-field-infix-width: 100px;
              margin-left: auto;
            "
        >
          <mat-select
            [value]="rate"
            (selectionChange)="onRateChangeLine($event)"
          >
            <mat-option class="bhm-option-select-option-1" value="hourly">
              {{ "words.hourly" | translate }}
            </mat-option>
            <mat-option
              class="bhm-option-select-option-1"
              value="day"
              [disabled]="isDayDisabled"
            >
              {{ "words.day" | translate }}
            </mat-option>
            <mat-option
              class="bhm-option-select-option-1"
              value="month"
              [disabled]="isMonthDisabled"
            >
              {{ "words.month" | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div
      style="height: 200px; overflow: hidden"
      fxFlex="100"
      *ngIf="firstLoader"
    >
      <div style="height: 200px">
        <google-chart
          class="chart performance-incentives-chart"
          [data]="incentivesLineChart"
          *ngIf="incentivesLineChart"
          (chartSelect)="
            onChartSelect(incentivesChartTitle, incentivesLineChart, $event)
          "
          (window:resize)="onResize($event)"
        >
        </google-chart>
      </div>
    </div>

    <div
      class="skeleton-fields"
      *ngIf="!firstLoader"
      style="display: flex; justify-content: space-between; gap: 20px"
    >
      <div>
        <ngx-skeleton-loader
          style="display: block !important; margin-bottom: 5px !important"
          count="1"
          [theme]="{
            height: '35px',
            outline: 'none',
            width: '130px',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div>
        <ngx-skeleton-loader
          style="display: block !important; margin-bottom: 5px !important"
          count="1"
          [theme]="{
            height: '25px',
            outline: 'none',
            width: '130px',
            'background-color': '#37474f1a',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div
      class="skeleton-chart-square"
      *ngIf="!firstLoader"
      style="width: 100%; margin-right: 10px; margin-top: 5px !important"
    >
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '220px',
          outline: 'none',
          width: '100%',
          'background-color': '#37474f1a',
        }"
      >
      </ngx-skeleton-loader>
    </div>
    <div
      class="skeleton-fields"
      *ngIf="!firstLoader"
      style="display: flex; justify-content: space-between; gap: 20px"
    >
      <div>
        <ngx-skeleton-loader
          style="display: block !important; margin-bottom: 5px !important"
          count="4"
          [theme]="{
            height: '35px',
            outline: 'none',
            width: '130px',
            'background-color': '#37474f1a',
            'margin-right': '15px',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div
      class="skeleton-chart-square"
      *ngIf="!firstLoader"
      style="width: 100%; margin-right: 10px; margin-top: 5px !important"
    >
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '220px',
          outline: 'none',
          width: '100%',
          'background-color': '#37474f1a',
        }"
      >
      </ngx-skeleton-loader>
    </div>
    <div class="loading-data-overlay" *ngIf="!chartLoaderSecondary">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
</div>

<div class="loading-data-overlay" *ngIf="!chartLoader">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<!-- Performance Overall second container-->

<!-- <app-detailed></app-detailed> -->
